module.exports = __webpack_public_path__ + "media/images/top/works08-c180a5e6ef8ae7d2b458ee0c39bef2ef.jpg";